import { render, staticRenderFns } from "./AddOn.vue?vue&type=template&id=66ea6180&scoped=true"
import script from "./AddOn.vue?vue&type=script&lang=js"
export * from "./AddOn.vue?vue&type=script&lang=js"
import style0 from "./AddOn.vue?vue&type=style&index=0&id=66ea6180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea6180",
  null
  
)

export default component.exports